import { duplicateGoal as _duplicateGoal } from '@griply/services';
import { getSubGoals } from '@griply/utils';
import {
  collection,
  doc,
  Firestore,
  serverTimestamp,
  Timestamp,
  writeBatch,
} from 'firebase/firestore';
import {
  FirestoreWriteOp,
  logFirestoreWriteError,
} from 'shared/services/error-tracking';
import { Goal } from 'shared/types/goal';

import { getGoals } from './get-goals';
import { getTasksWithSubTasks } from './get-tasks-with-sub-tasks';
import { getDatabase } from './helpers';

export const duplicateGoal = async (goal: Goal) => {
  const goals = await getGoals();
  const subGoals = getSubGoals(goal.id, { goals, recursive: true });
  const tasks = await getTasksWithSubTasks({
    goals: [goal.id, ...subGoals.map(({ id }) => id)],
  });

  return _duplicateGoal({
    goal,
    subGoals,
    tasks,
    collection,
    doc,
    db: getDatabase(),
    serverTimestamp,
    timestampFromDate: Timestamp.fromDate,
    writeBatch: (db) => writeBatch(db as Firestore),
    onWriteError: (error) =>
      logFirestoreWriteError({
        op: FirestoreWriteOp.DuplicateGoal,
        error,
      }),
  });
};
